module.exports = __webpack_public_path__ + "static/media/giwah.23453f6e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/about-us/giwah.png
// module id = 1151
// module chunks = 0